module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cms-module/common/get-datasource-box/get-datasource-box.component.scss
// module id = ./src/app/modules/cms-module/common/get-datasource-box/get-datasource-box.component.scss
// module chunks = 9